import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const icons = {
    RequestQuoteIcon,
    AssignmentTurnedInIcon,
    PendingActionsIcon,
    TaskAltIcon
};

const invoicingFinGroup = {
    id: "invoice_finance",
    title: "Invoicing",
    type: "group",
    icon: icons.RequestQuoteIcon,
    children: [
        {
            id: "invoice_finance_1",
            title: "Invoice",
            type: "item",
            url: "/invoice",
            icon: icons.RequestQuoteIcon,
        },
        {
            id: "assign_billing_finance_1",
            title: "Assign Billing Type",
            type: "item",
            url: "/Assign_Billing_Type",
            icon: icons.AssignmentTurnedInIcon,
        },
        {
            id: 'Pending_Approval_Tech_Fin',
            title: 'Pending Approval',
            type: 'item',
            url: '/approval',
            icon: icons.PendingActionsIcon,
        },
        {
            id: 'Approved_Batches_Tech_Fin',
            title: 'Approved Batches',
            type: 'item',
            url: '/ApprovedBatches',
            icon: icons.TaskAltIcon,
        },
    ],
};

export default invoicingFinGroup;